import { render, staticRenderFns } from "./ServiceVisitBoardTaskModal.vue?vue&type=template&id=dbfae8d8&scoped=true&"
import script from "./ServiceVisitBoardTaskModal.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitBoardTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitBoardTaskModal.vue?vue&type=style&index=0&id=dbfae8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfae8d8",
  null
  
)

export default component.exports